module.exports = __webpack_public_path__ + "static/media/profile.23b1295a.JPG";